import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import { useMatch } from "react-router-dom";
import moment from "moment";
import henceforthApi from "../utils/henceforthApi";
import PaginationLayout from "../components/PaginationLayout";
import { getUserProfileImage } from "../utils/constant_value";
function ViewActivityOfUser({ loading ,getActivity}) {
  const match = useMatch("/user/:id/:type");
  const navigate = useNavigate()
  // const [getActivity, setGetActivity] = useState([]);
  const [totalCount, setTotalCount] = useState(0)
  const [page, setPage] = useState(1)
  const limit = 10
  // const userDetailActivity = async (_id) => {
  //   // setLoading(true);
  //   let apiRes = await henceforthApi?.User?.getUserActivity(match?.params?.id, Number(page) - 1, limit);
  //   // setLoading(false);
  //   // setData(apiRes?.data)
  //   // setTotalCount(apiRes?.data.length)
  //   setGetActivity(apiRes?.data);
  //   setTotalCount(apiRes?.count)
  // };
  //userActivity
  // const [getActivity, setGetActivity] = useState([]);
  // const userDetailActivity = async (_id) => {
  //   let apiRes = await henceforthApi?.User?.getUserActivity(match?.params?.id, _id);
  //   setGetActivity(apiRes?.data);

  // };
  const otherUserProfile = (id) => {
    // navigate(`/user/${id}`)
  }
  const activityType = (type, id, other_userId) => {
    if (type == "POST") {
      navigate(`/media/${id}/like`)
    }
    else if (type == "REEL") {
      navigate(`/media/${id}/like`)
    }
    else if (type == "STORY") {
      navigate(`/media/${id}/view`)
    }
    else if (type == "COINS") {
      navigate(`/media/${id}/coins`)
    }
    else if (type == "Follow") {
      navigate(`/user/${other_userId}/1/1?type=posts`)
    }
    else if (type == "IMAGE") {
      navigate(`/media/${id}/like`)
    }
    // else if(type == null){
    //   navigate(`/media/${id}/like`)
    // }
  }
  const onChangePagination = (val) => {
    // const newParam = new URLSearchParams(location.search);
    //   navigate(`/user/${newVal}`);
    setPage(Number(val))
  };
  useEffect(() => {
    // userDetailActivity();
  }, [match?.params?.id, page]);
  // console.log(item);
  return (
    <div>
      {" "}
      <div className="row">
        {!loading && getActivity?.length ? getActivity?.map((item, index) => {
          const send_coins = item?.activity?.indexOf("to")
          const coins_sending_user = item?.activity?.slice(send_coins + 2, item?.activity?.length)
          const activity = item?.activity?.split(" ")
          const my_activity = activity?.length ? activity[0] : "";
          const other_activity = activity?.length ? activity[activity?.length - 1] : "";
          const coins_get_user= item?.activity?.includes("to") ? item?.activity.slice(my_activity?.length , send_coins + 2) : ""
          const other_activity_length = item?.activity?.length - other_activity?.length
          const activity_data = item?.activity?.length ? item?.activity?.slice(my_activity?.length, other_activity_length) : ""
          return (
            <div className="col-sm-6" key={index} style={{ cursor: "pointer" }}>
              <div
                className="modal-wrapper d-flex justify-content-between align-items-start"
                onClick={() => { activityType(item?.type, item?.post_id, item?.sent_to) }}
                style={{
                  border: "1px solid #e5e5e5",
                  borderRadius: "5px",
                  padding: "10px",
                  marginBottom: "10px",
                }}
              >
                <div className="image-name-box d-flex gap-2 align-items-center w-100">
                  <div className="image-box">
                    <img
                      src={getUserProfileImage(item?.profile_pic)}
                      alt="ProfileImage"
                      class="modal-profile"
                    />
                  </div>
                  <div className="d-flex align-item-center justify-content-between w-100">
                    {/* <Link to={item?.type == "POST" ? `/user/${item.post_id}`: item?.type == "POST"}> */}
                    <div className="name-box">
                      <p
                        className="m-0"
                        style={{
                          fontSize: "15px",
                        }}
                      >
                        <span> {item?.activity ? <><b style={{ cursor: "pointer" }}>{my_activity}</b> {item.activity?.includes("to") ? coins_get_user :activity_data} {(other_activity == "POST" || other_activity == "REEL" || other_activity == "STORY") ? other_activity : <b onClick={() => otherUserProfile(item?.sent_to)} style={{ cursor: "pointer" }}>{item.activity?.includes("to") ? coins_sending_user : other_activity}</b>} </> : "Not available"}</span>
                        {/* <Link to={`/user/${item?.user_id}`} className="Details_of_User fw-bold">
                        <span> {item?.name ? item?.name : "Not available"}</span>
                      </Link>{" "}
                      <Link to={`/user/${item?.post_id}`} className="Details_of_User fw-bold">
                        <span> {item?.type ? item?.type : "Not available"}</span>
                      </Link>{" "} */}
                      </p>
                    </div>
                    {/* </Link> */}
                    <div className="">
                      <p
                        className="m-0"
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        {moment(Number(item?.created_at)).format(
                          "DD MMM YYYY, h:mm a"
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }) : <div className="text-center">No Activity Found</div>}
      </div>
      {/* <PaginationLayout
        count={totalCount}
        data={getActivity}
        page={Number(page)}
        limit={Number(limit)}
        loading={loading}
        onPageChange={(val) => onChangePagination(val)}
      /> */}
    </div>
  );
}

export default ViewActivityOfUser;
